module.exports = __webpack_public_path__ + "img/page-21.8cd72d59.jpg";